<template>
  <el-dialog :title="'知识发现建议 - ' + (doc ? doc.title || doc.filename : '')" :visible.sync="localVisible"
             width="640px" v-dialogDrag :modal-append-to-body="false" v-if="localVisible && doc">
    <div v-loading="loading" class="sug_wrap">
      <div v-for="sug in list" :key="sug.suggestion_id" class="sug_item">
        <div class="sug_head">
          <el-tag size="small" type="info">{{ sug.type }}</el-tag>
          <span class="sug_title" :title="sug.title">{{ sug.title }}</span>
          <span class="sug_conf">置信度 {{ fmtConf(sug.confidence) }}</span>
          <el-tag :type="statusMeta(sug.status).type" size="mini">{{ statusMeta(sug.status).text }}</el-tag>
        </div>
        <div class="sug_summary">{{ sug.summary || '-' }}</div>
        <div v-if="sug.status === 'auto' || sug.status === 'validated'" class="sug_ops">
          <el-button type="primary" size="mini" :loading="sug.operating" @click="handleOp('confirm', sug)">确认</el-button>
          <el-button size="mini" :loading="sug.operating" @click="handleOp('discard', sug)">丢弃</el-button>
        </div>
      </div>
      <div v-if="!list.length && !loading" class="sug_empty">该文档暂无知识发现建议</div>
    </div>
  </el-dialog>
</template>

<script>
import { agentBody } from '../utils'

// 知识发现建议弹窗：discovery/list 按文档查询；确认/丢弃后刷新并通知父组件
export default {
  name: 'AiAgentKbDiscovery',
  props: {
    visible: { type: Boolean, default: false },
    doc: { type: Object, default: null }
  },
  data() {
    return {
      localVisible: this.visible,
      list: [],
      loading: false
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
      if (val && this.doc) this.load()
    },
    localVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    load() {
      this.loading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDiscoveryList,
        agentBody({ doc_id: this.doc.doc_id })).then((res) => {
        if (res.data.code == 0) this.list = res.data.data || []
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleOp(action, sug) {
      const url = action === 'confirm' ? this.$baseUrl.aiAgentKbDiscoveryConfirm : this.$baseUrl.aiAgentKbDiscoveryDiscard
      this.$set(sug, 'operating', true)
      this.$tools.asyncPost(this, url,
        agentBody({ doc_id: this.doc.doc_id, suggestion_id: sug.suggestion_id })).then((res) => {
        sug.operating = false
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: res.data.msg || '操作成功' })
          this.load()
          this.$emit('refresh') // 同步父组件文档行的 discovered_skills 计数
        }
      }).catch((err) => {
        sug.operating = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
      })
    },
    statusMeta(status) {
      const map = {
        auto: { text: '待处理', type: '' },
        validated: { text: '已校验', type: 'warning' },
        confirmed: { text: '已确认', type: 'success' },
        discarded: { text: '已丢弃', type: 'info' }
      }
      return map[status] || { text: status, type: 'info' }
    },
    fmtConf(c) {
      if (c === null || c === undefined) return '-'
      return Math.round(c * 100) + '%'
    }
  }
}
</script>

<style lang="less" scoped>
.sug_wrap {
  min-height: 100px;
  max-height: 480px;
  overflow-y: auto;
}
.sug_item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 8px;
}
.sug_head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sug_title {
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sug_conf {
  color: #409eff;
  font-size: 13px;
  flex-shrink: 0;
  margin-left: auto;
}
.sug_summary {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin: 6px 0;
}
.sug_ops {
  text-align: right;
}
.sug_empty {
  text-align: center;
  color: #909399;
  padding: 24px 0;
  font-size: 13px;
}
</style>
